// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".div-control {\n  background: white !important;\n  height: auto;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/global/DivLabeled.vue"],"names":[],"mappings":"AACE;EACE,4BAAA;EACA,YAAA;AAAJ","sourcesContent":["\r\n  .div-control{\r\n    background: white !important;\r\n    height: auto;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
